import { useState } from 'react'
import { Sparkles } from 'lucide-react'
import { toast } from 'sonner'
import { useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { runAiAnalysis } from '@/api/achievements'
import type { AnalyzeResult } from '@/api/achievements'
import AiResultOverlay from '@/components/feature/AiResultOverlay'
import { unlockAudio } from '@/lib/sfx'

export default function AiAnalyzeButton() {
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState<AnalyzeResult | null>(null)
  const qc = useQueryClient()

  const handleClick = async () => {
    // クリック中（await より前）に音声を解放しておき、判定完了後のカットインで鳴らせるようにする
    unlockAudio()
    setLoading(true)
    try {
      const res = await runAiAnalysis()
      qc.invalidateQueries({ queryKey: ['achievements'] })
      qc.invalidateQueries({ queryKey: ['status'] })
      qc.invalidateQueries({ queryKey: ['originalTrophies'] })
      if (res.processed === 0) {
        toast.info('判定対象の実績がありません')
      } else if (res.total_earned_points === 0) {
        // AI が想定外の ai_rating を返すと獲得が全て 0 になる。
        // リザルト演出が空になるため、その場合はトーストで済ませる。
        toast.info(`実績${res.processed}件を判定しました（獲得なし）`)
      } else {
        setResult(res)
      }
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.status === 503) {
        toast.error('現在AI判定は利用不可能です')
      } else {
        toast.error('AI判定に失敗しました')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        disabled={loading}
        className="flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border border-green-500 text-green-600 mr-1 min-h-[32px] disabled:opacity-50"
      >
        <Sparkles size={13} className={loading ? 'animate-spin' : ''} />
        {loading ? '判定中...' : 'AI判定'}
      </button>

      {result && <AiResultOverlay result={result} onClose={() => setResult(null)} />}
    </>
  )
}
